export default __webpack_public_path__ + "static/media/shopifyNativeConcent5.163b1ac1.svg";